module.exports = ".exceed_warning{\n    color: #FC0404;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/personal/personal.component.css
// module id = ./src/app/main/content/personal/personal.component.css
// module chunks = main